import IconAsMaskImage from "../IconAsMaskImage";

function FileIcon({ pureSvg, className, color }) {
  const svg = (
    <svg
      width="24"
      height="29"
      viewBox="0 0 24 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7682 0C14.1316 0 14.4112 0.296471 14.4112 0.649412V5.19529C14.4112 7.77882 16.5218 9.89647 19.0798 9.91059C20.1421 9.91059 20.9808 9.92471 21.6238 9.92471L21.8619 9.92366C22.2916 9.92039 22.8701 9.91059 23.371 9.91059C23.7204 9.91059 24 10.1929 24 10.5459V21.8965C24 25.3976 21.1904 28.2353 17.7239 28.2353H6.59755C2.96331 28.2353 0 25.2565 0 21.5859V6.36706C0 2.86588 2.82353 0 6.30402 0H13.7682ZM15.2638 18.2118H7.65987C7.08678 18.2118 6.61153 18.6776 6.61153 19.2565C6.61153 19.8353 7.08678 20.3153 7.65987 20.3153H15.2638C15.8369 20.3153 16.3122 19.8353 16.3122 19.2565C16.3122 18.6776 15.8369 18.2118 15.2638 18.2118ZM12.3844 11.1529H7.65987C7.08678 11.1529 6.61153 11.6329 6.61153 12.2118C6.61153 12.7906 7.08678 13.2565 7.65987 13.2565H12.3844C12.9575 13.2565 13.4327 12.7906 13.4327 12.2118C13.4327 11.6329 12.9575 11.1529 12.3844 11.1529ZM16.448 1.27906C16.448 0.670588 17.1791 0.368471 17.597 0.807529C19.108 2.39435 21.7484 5.16847 23.2245 6.71859C23.6327 7.14635 23.3335 7.85647 22.7451 7.85788C21.5961 7.86212 20.2416 7.85788 19.2674 7.848C17.7214 7.848 16.448 6.56188 16.448 5.00047V1.27906Z"
        fill="#868686"
      />
    </svg>
  );
  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
}

export default FileIcon;
